import React, { Component } from 'react';
import Formulario from './ListadoPreciosForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class ListadoPrecios extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo } = this.props;
        const id = match.params.id;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        getModulo(modulo[5],modulo[4]);
        
    }
    
    render(){
        const { registroPrecio, modificarPrecio, loader, 
            lectura, modulo } = this.props;
        const { crear } = this.state;
        const funcionEnvio = crear ? registroPrecio : modificarPrecio;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    lectura = {lectura}
                    modulo = {modulo}
                    registroPrecio = {funcionEnvio}
                    modificarPrecio = {modificarPrecio}
                />
            </LoadMask>
        );
    }
}

export default ListadoPrecios
